import type { Config } from "./Config";

/** Extends the Config with logic */
export class ConfigLogic implements Config {

  /** The base address of the Salaxy http API server, e.g. https://secure.salaxy.com */
  apiServer?: string | null;

  /** The base address of the Palkkaus web site, e.g. https://www.palkkaus.fi */
  wwwServer?: string | null;

  /** A flag indicating if the current configuration is for test environment only. If true, the site is for testing only. */
  isTestData?: boolean | null;

  /** A flag indicating if the site sets a Salaxy cookie which persists over web sessions. If true, the cookie will be created. */
  useCookie?: boolean | null;

  /** A flag indicating if the API site uses credentials. If true, the credentials will be used. */
  useCredentials?: boolean | null;

  /** InstrumentationKey for Application Insight */
  instrumentationKey?: string | null;

  /** Partner id for site. This is required for example for onboarding with partner specific style. */
  partnerSite?: string | null;

  /** Pro server site address. e.g. https://pro.palkkaus.fi */
  proServer?: string | null;

  /** Report server url */
  reportServer?: string | null;

  /** Application id for invoicing. */
  applicationId?: string | null;

  /** The base address of the integrations server, e.g. https://integrations.salaxy.com */
  integrationsServer?: string | null;

  /** The base address of the code editor server, e.g. https://code-editor.salaxy.com */
  codeEditor?: string | null;

  /**
   * Creates a new ConfigLogic based on a Config in env file.
   * @param config Raw config in env file.
   */
  constructor(config: Config) {
    Object.assign(this, config);
  }

  /** Gets the type of the environment. */
  public getEnv(): "local" | "test" | "demo" | "prod" | "rc" {
    if ((this.apiServer?.indexOf("localhost") ?? -1) > -1) {
      return "local";
    }
    if ((this.apiServer?.indexOf("rc") ?? -1) > -1) {
      return "rc";
    }
    if ((this.integrationsServer?.indexOf("test") ?? -1) > -1) {
      return "test";
    }

    if (!this.isTestData) {
      return "prod";
    }
    return "demo";
  }

  /** Gets the server address for the Omapalkka service based on environment. */
  public getOmapalkkaServer(): string {
    switch (this.getEnv()) {
      case "prod":
        return "https://www.omapalkka.fi";
      case "local":
        return "http://localhost:3000";
      case "test":
        return "https://test-www.omapalkka.fi";
      case "rc":
      case "demo":
      default:
        return "https://demo-www.omapalkka.fi";
    }
  }

  /** Gets the API server address for the Omapalkka service based on environment. */
  public getOmapalkkaApiServer(): string {
    switch (this.getEnv()) {
      case "prod":
        return "https://secure.omapalkka.fi";
      case "local":
        return "https://localhost:7270";
      case "test":
        return "https://test-secure.omapalkka.fi";
      case "rc":
      case "demo":
      default:
        return "https://demo-secure.omapalkka.fi";
    }
  }

}